import classNames from 'classnames'
import CommonIcon from 'CommonIcon'
import PropTypes from 'prop-types'
import React from 'react'
import { countryIdToString } from 'utils'

import Box from '@mui/material/Box'

const Name = ({ cluster, countryId, isL4L, storeName, storeChannel }) => (
  <Box className="search-list_item-name">
    <Box className="search-list_item-name_wrapper flex-row">
      <Box display="flex">
        {!storeChannel && (
          <Box className={classNames('category', `is-${cluster === '-' ? 'none' : cluster.toLocaleLowerCase()}`)}>{cluster}</Box>
        )}
        {storeChannel && <CommonIcon className="search-list_item-name-icon" name={storeChannel} />}
        {isL4L && <span className="l4l-small-icon mobile-only" />}
      </Box>
      <Box className="flex-column">{storeName}</Box>
      <CommonIcon name={countryIdToString(countryId)} />
    </Box>
  </Box>
)

Name.propTypes = {
  cluster: PropTypes.string,
  countryId: PropTypes.string,
  isL4L: PropTypes.bool,
  storeName: PropTypes.string,
}

export default Name
